export const footerLinkInfos = [
  {
    name: "運営会社",
    href: "https://graffer.jp/",
    blank: true,
  },
  {
    name: "Graffer アカウント規約",
    href: "https://graffer.jp/legal/account-policy",
    blank: true,
  },
  {
    name: "プライバシーポリシー",
    href: "https://graffer.jp/legal/privacy-policy",
    blank: true,
  },
];
